<td class="px-6 py-4 text-sm text-center">
  <ng-content></ng-content>
</td>
